import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { useIsLoggedOutSuppliersLayoutElementLoading } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersLayoutElement/useIsLoggedOutSuppliersLayoutElementLoading";
import { LoggedOutSuppliersPageBreadcrumb } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageHeader/__internal__/LoggedOutSuppliersPageBreadcrumb/LoggedOutSuppliersPageBreadcrumb";
import { SuppliersPageHeaderLoadingSkeleton } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/SuppliersPageHeaderLoadingSkeleton";
import { trackCategoriesGetStartedCtaClick } from "@faire/web-api--source/events/categories/click/getStartedCta";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Lock } from "@faire/web/slate/icons/foundation/Lock";
import { Column, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";

import { useHeaderCarouselCategoriesToDisplay } from "../../useHeaderCarouselCategoriesToDisplay";

import { LoggedOutSuppliersPageHeaderCategoryCarousel } from "./__internal__/LoggedOutSuppliersPageHeaderCategoryCarousel";

interface IProps {
  title: string | undefined;
}

export const LoggedOutSuppliersPageHeader: React.FC<IProps> = ({ title }) => {
  const history = useHistory();
  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const categoriesToDisplay = useHeaderCarouselCategoriesToDisplay();
  const { isDesktopAndAbove } = useViewport();
  const shouldShowCarousel = isDesktopAndAbove && !!categoriesToDisplay.length;

  const isLoading = useIsLoggedOutSuppliersLayoutElementLoading();

  if (isLoading) {
    return <SuppliersPageHeaderLoadingSkeleton />;
  }

  return (
    <Column className="mt-6 w-full gap-2 px-4 lg:mt-8 lg:px-12">
      <LoggedOutSuppliersPageBreadcrumb category={categoryModel} />
      <Row className="w-full" align="center">
        <Column className="flex-1">
          <Typography
            variant={{
              mobileAndAbove: "pageHeaderSerifRegular",
              desktopAndAbove: "displaySSerifRegular",
            }}
            as="h1"
            className="break-word lg:w-80% w-full"
          >
            {title}
          </Typography>
          <Spacer height="1x" />
          <Button
            className="self-start"
            variant="tertiary"
            onClick={() => {
              trackCategoriesGetStartedCtaClick(
                categoryModel.mostSpecificPathIdentifier ?? ""
              );
              popSignUp(history, SignUpType.GENERIC, () => {}, {
                element: SignUpElement.HERO,
                sourceId: "suppliers_page_hero_signup_cta",
              });
            }}
          >
            <Lock lockType="foundation" fontSize={16} />
            <Spacer width={4} />
            <StrictLocalMsg
              id="YUPe3W"
              defaultMessage="Unlock wholesale pricing"
              description={{
                text: "sign up cta for discover page header",
              }}
            />
          </Button>
        </Column>
        {shouldShowCarousel ? (
          <div
            data-test-id="logged-out-suppliers-page-header-carousel"
            className="w-1/2"
          >
            <LoggedOutSuppliersPageHeaderCategoryCarousel
              categoryPathIdentifier={categoryModel.mostSpecificPathIdentifier}
            />
          </div>
        ) : null}
      </Row>
    </Column>
  );
};
